import { css } from '@emotion/core';

export const licenseInformationMobileCSS = css`
    display: flex;
    flex-direction: column;
    padding: 1.5rem;
    height: 100vh;
`;

export const licenseInformationHeaderMobileCSS = css`
    display: flex;
    justify-content: space-between;
    padding-bottom: 1rem;
`;

export const licenseInformationHeaderTextMobileCSS = css`
    padding: 0.5rem;
    font-size: larger;
`;

export const licenseInformationMobileFooterCSS = css`
    width: 100%;
    display: inline-block;

    button {
        height: 2.5rem;
        min-width: 5rem;
        float: right;
    }
`;

export const licenseInformationCloseOverlayButtonCSS = ({ colors }) => css`
    border-radius: 2.5rem;
    height: 2.5rem;
    width: 2.5rem;

    > svg {
        color: ${colors.neutral30};
        &:hover,
        &:active,
        &:focus {
            color: ${colors.neutral30};
        }
    }
`;
